import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Alert, Button, Card, Form, Input, Typography, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { login } from '../utils/auth';

const { Title, Text } = Typography;

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState('');

  const from = location.state?.from || '/';

  const handleSubmit = async ({ userId, password }) => {
    setLoading(true);
    setLoginError('');

    try {
      await login(userId, password);
      message.success(t('login.success'));
      navigate(from, { replace: true });
    } catch (err) {
      const isAuthError = err.status === 401;
      const errorMessage = isAuthError ? t('login.passwordError') : err.message || t('login.error');
      setLoginError(errorMessage);
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-wabi-cream-100 px-3 sm:px-4 py-6">
      <Card className="w-full max-w-md shadow-lg border-0">
        <div className="text-center mb-6 sm:mb-8">
          <Title level={2} className="!text-wabi-brown-800 !mb-2 !text-xl sm:!text-2xl">
            許記雞場
          </Title>
          <Text className="text-gray-500">{t('login.subtitle')}</Text>
        </div>

        {loginError && (
          <Alert
            type="error"
            message={loginError}
            showIcon
            className="mb-4"
            closable
            onClose={() => setLoginError('')}
          />
        )}

        <Form layout="vertical" onFinish={handleSubmit} size="large">
          <Form.Item
            name="userId"
            label={t('login.userId')}
            rules={[{ required: true, message: t('login.userIdRequired') }]}
          >
            <Input prefix={<UserOutlined />} placeholder={t('login.userIdPlaceholder')} />
          </Form.Item>

          <Form.Item
            name="password"
            label={t('login.password')}
            rules={[{ required: true, message: t('login.passwordRequired') }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder={t('login.passwordPlaceholder')}
            />
          </Form.Item>

          <Form.Item className="mb-0">
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              className="bg-wabi-brown-700 hover:bg-wabi-brown-800"
            >
              {t('login.submit')}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
